import React from "react";
import MerchantWhiteList from "modules/merchantWhiteList";

const MerchantWhiteListPage = () => {
  return <MerchantWhiteList />;
};

export default MerchantWhiteListPage;
